export default __webpack_public_path__ + "static/media/Brow_2_C3.cbe2408d.svg";